module.exports = __webpack_public_path__ + "img/block-1920.8efa63e0.jpg";